export default "__VITE_ASSET__BXrJ4t0h__"